import { connect } from 'react-redux';
import {
  Table,
  TableRow,
  TableBody,
  TableHead,
  TableCell,
  List,
  ListSubheader,
  ListItem,
  Paper,
  CircularProgress,
} from '@mui/material';
import { AUTH_LEVELS } from '../../auth/Authorized';
import getBuildingStaging from '../../../redux/selectors/staging';
import { groupListByProperty } from '../../../utils/collections';

const Overview = ({ pointsLoaded, equipmentLoaded, stagingPoints, stagingEquipment }) => {
  const points = stagingPoints.length;
  const pointsPublished = stagingPoints.filter((p) => p.published).length;
  const pointsValid =
    pointsLoaded && stagingPoints.every((p) => p.validation)
      ? stagingPoints.filter((p) => p?.validation.length === 0).length
      : undefined;

  const equipment = stagingEquipment.length;
  const equipmentPublished = stagingEquipment.filter((e) => e.published).length;
  const equipmentValid =
    equipmentLoaded && stagingEquipment.every((e) => e.validation)
      ? stagingEquipment.filter((e) => e?.validation.length === 0).length
      : undefined;
  return (
    <>
      <Paper style={{ maxHeight: 200, overflow: 'auto' }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell />
              <TableCell>Total</TableCell>
              <TableCell>Total Valid</TableCell>
              <TableCell>Total Published</TableCell>
              <TableCell>Percent Published</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>Points</TableCell>
              <TableCell>
                {pointsLoaded ? points : <CircularProgress size="24px" aria-label="Loading…" />}
              </TableCell>
              <TableCell>
                {' '}
                {pointsLoaded && Number.isInteger(pointsValid) ? (
                  pointsValid
                ) : (
                  <CircularProgress size="24px" aria-label="Loading…" />
                )}
              </TableCell>
              <TableCell>
                {pointsLoaded ? (
                  pointsPublished
                ) : (
                  <CircularProgress size="24px" aria-label="Loading…" />
                )}
              </TableCell>
              <TableCell>
                {pointsLoaded ? (
                  (points === 0 && '0.00%') || `${((pointsPublished / points) * 100.0).toFixed(2)}%`
                ) : (
                  <CircularProgress size="24px" aria-label="Loading…" />
                )}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Equipment</TableCell>
              <TableCell>
                {equipmentLoaded ? (
                  equipment
                ) : (
                  <CircularProgress size="24px" aria-label="Loading…" />
                )}
              </TableCell>
              <TableCell>
                {' '}
                {equipmentLoaded && Number.isInteger(equipmentValid) ? (
                  equipmentValid
                ) : (
                  <CircularProgress size="24px" aria-label="Loading…" />
                )}
              </TableCell>
              <TableCell>
                {equipmentLoaded ? (
                  equipmentPublished
                ) : (
                  <CircularProgress size="24px" aria-label="Loading…" />
                )}
              </TableCell>
              <TableCell>
                {equipmentLoaded ? (
                  (equipment === 0 && '0.00%') ||
                  `${((equipmentPublished / equipment) * 100.0).toFixed(2)}%`
                ) : (
                  <CircularProgress size="24px" aria-label="Loading…" />
                )}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Paper>
      <Paper>
        <List
          sx={{ listStyleType: 'disc' }}
          subheader={<ListSubheader>Equipment Counts</ListSubheader>}
        >
          {equipmentLoaded ? (
            Object.entries(groupListByProperty('equipmentTypeId', stagingEquipment))
              .map((pair) => [pair[1][0].equipmentType, pair[1].length])
              .toSorted((a, b) => a[1] < b[1])
              .map(([equipmentType, count]) => (
                <ListItem key={equipmentType?.id || 'undefined'} sx={{ display: 'list-item' }}>
                  <b>{equipmentType?.nameLong ?? 'undefined'}</b> - {count}
                </ListItem>
              ))
          ) : (
            <CircularProgress size="24px" aria-label="Loading…" />
          )}
        </List>
      </Paper>
    </>
  );
};

const mapStateToProps = (state, { building }) => {
  const {
    user: { userAuthLevel },
    entities: {
      staging: { pointsLoadTime, equipmentLoadTime },
    },
  } = state;
  const { stagingPoints, stagingEquipment } = getBuildingStaging(state, building.id);
  return {
    stagingPoints: [...stagingPoints.values()],
    stagingEquipment: [...stagingEquipment.values()],
    isSuperAdmin: userAuthLevel === AUTH_LEVELS.SUPER_ADMIN,
    canWrite: userAuthLevel < AUTH_LEVELS.ORG_USER,
    equipmentLoaded: equipmentLoadTime[building.id],
    pointsLoaded: pointsLoadTime[building.id],
  };
};

// eslint-disable-next-line no-unused-vars
const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Overview);
